import { useState } from "react";
import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { NavLink, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import Button from '@mui/material/Button';
import { BsStopwatchFill } from "react-icons/bs";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { logout } from "../redux/authSlice";
import { toast } from "react-toastify";
import { buttonStyle, listItemStyle } from "./SideNavStyles";
import { PermIdentity, Settings } from "@mui/icons-material";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { GrDocumentPerformance } from "react-icons/gr";
import { Avatar } from "@mui/material";
import { Link } from "react-router-dom";
import { useIndexPageData } from "../contextapi/Indexpagedata";
// import MuiDialog from "../components/MuiDialog";

const drawerWidth = 230;
const listItemData = [
  //   { label: "Classes & Students", icon: <svg id="Group_16" data-name="Group 16" xmlns="http://www.w3.org/2000/svg" width="29.35" height="29.35" viewBox="0 0 67.35 67.35">
  //   <path id="Shape" d="M51.564,67.35H15.785A15.8,15.8,0,0,1,0,51.565V15.786A15.8,15.8,0,0,1,15.785,0H51.564A15.8,15.8,0,0,1,67.35,15.786V51.565A15.8,15.8,0,0,1,51.564,67.35ZM15.785,5.261A10.537,10.537,0,0,0,5.261,15.786V51.565A10.537,10.537,0,0,0,15.785,62.089H51.564A10.537,10.537,0,0,0,62.089,51.565V15.786A10.537,10.537,0,0,0,51.564,5.261ZM52.748,56.825H46.961a2.63,2.63,0,1,1,0-5.261h5.787a2.63,2.63,0,1,1,0,5.261ZM49.2,46.569H27.229a2.632,2.632,0,0,1,0-5.264H49.2a2.632,2.632,0,0,1,0,5.264ZM25.123,15.916H14.075a2.63,2.63,0,1,1,0-5.261H25.123a2.63,2.63,0,1,1,0,5.261Z" transform="translate(0 0)" fill="#cf242a"/>
  //   <path id="Shape-2" data-name="Shape" d="M36.436,15.39H17.891a2.629,2.629,0,1,1,0-5.258H36.436a2.629,2.629,0,1,1,0,5.258ZM27.229,5.264H2.632A2.632,2.632,0,0,1,2.632,0h24.6a2.632,2.632,0,0,1,0,5.264Z" transform="translate(16.706 20.914)" fill="#cf242a"/>
  // </svg>
  //  },
  {
    label: "Dashboard",
    link: `/admin/dashboard`,
    
  },
  
 
  {
    label: "Mockups",
    link: "admin/mockups-listing",

  },
  // {
  //   label: "Payments",
  //   link: "/payments-details",

  // },
  {
    label: "Sellers",
    link: "/admin/sellers",

  },
  {
    label: "Buyers",
    link: "/admin/buyers",

  },
  {
    label: "Categories Edit",
    link: "/admin/categories-edit",

  },
  {
    label: "Featured Mockup",
    link: "/admin/featuremockup",

  },
  {
    label: "Featured Sections",
    link: "/admin/featured-sections",

  },
  {
    label: "Settings",
    link: "/admin/settings",

  },
  {
    label: "Logout",
    icon: <LogoutIcon />,
    isLogout: true,
  },
  
  
  
  


];




function SideNav(props) {
  const { profiledata, setprofiledata } = useIndexPageData();
  const [show, setShow] = useState(false)
  const { window } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    toast.success("Log out Successfully");
    navigate("/");
    setprofiledata([]);
    if (props.mobileOpen && props.handleDrawerToggle) {
      props.handleDrawerToggle();
    }
  };
  const drawer = (
    <div className="" style={{ backgroundColor: "#181922", height: "100vh", zIndex:"1" }}>
      <div className="zoom pt-5 ">


        
        <Link style={{fontSize:"25px"}} className=" ms-2 text-white fs-bold text-decoration-none logo" >
      <div className='d-flex justify-content-center mt-n5  gap-2 align-items-center '>
      <Avatar src={ profiledata.profile} alt="logo" />
      <h5 className='mb-0'> {profiledata.full_name} </h5>
      </div>
      <h5 className="text-center my-3"> Admin dashboard </h5>
 
      {/* <h6 className="text-white text-center px-3 py-2  w-75 ms-auto me-2    mt-2" style={{backgroundColor:"#C93312" , borderBottomLeftRadius:"8px" , borderBottomRightRadius:"8px" , fontSize:"14px"}}>User dashboard</h6> */}
   
    
      {/* <div style={{ width: "10rem" }}>
        <img width="100%"
          src={require("../assets/HealthHop logo reverse on dark background (1).png" )}
        />
      </div> */}
      {/* <div className="" style={{width:"7rem"}}>
      <img width={"100%"} src={require("../assets/HealthHop logo reverse on dark background (1).png")} alt="" />
      </div> */}
    </Link>
        

        <List className="pt-5">
          {listItemData.map((value, i) => (
            <div key={i}>
              <div className=" my-0  mx-3 rounded-3 " >
                <RenderItem
                  value={value}
                  i={i}
                  style={{ fontSize: "2rem" }}
                  onLogout={handleLogout}
                />
              </div>
            </div>
          ))}
        </List>

        
      </div>
      {/* {show &&
          <MuiDialog 
            // title={"Logout"}
            title={"Are you sure you want to Logout?"} 
            show={show}
            // onHide={show}
            Buttons={
              ()=>(<>
              <Button
              onClick={() => { setShow(false); }}
              >Cancel
              </Button>
                <Button  
                onClick={() => {
               dispatch(logout())
               navigate('/')
                 }}
                 color="error" variant="contained">
                  Logout
                </Button>
              </>
              )
            }
            />
          } */}
    </div>
  );




  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box
      className=""
      component="nav"
      sx={{
        width: { md: drawerWidth },
        flexShrink: { md: 0 },
        bgcolor: "black",
      }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        container={container}
        variant="temporary"
        open={props.mobileOpen}
        onClose={props.handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            bgcolor: "#272938",
            color: "#AFB7BE",
            zIndex: { md: 900, xs: 900 },
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer

        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            bgcolor: "#272938",
            color: "#AFB7BE",
            width: drawerWidth,
            zIndex: { md: 900, xs: 900 },
          },
        }}
        open
      >
        {drawer}
      </Drawer>

    </Box>
  );
}


SideNav.propTypes = {
  window: PropTypes.func,
};

export default SideNav;



const RenderItem = ({ value, i, onLogout }) => {
  if (value.isLogout) {
    return (
      <ListItem key={i} disablePadding sx={listItemStyle}>
        <ListItemButton
          type="button"
          className="list-item list_text rounded-3 px-3 py-2"
          sx={{ ...buttonStyle }}
          onClick={onLogout}
        >
          <ListItemIcon className="myIconClass" sx={{ color: "#A7AEBF", marginRight: -3 }}>
            {value.icon}
          </ListItemIcon>
          <ListItemText
            className=""
            primary={
              <Typography
                variant="body1"
                style={{ fontSize: 16, color: "#fff", paddingLeft: 0 }}
                title={value.label}
              >
                {value.label}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
    );
  }

  return (
    value.link ? <ListItem
      key={i}
      component={NavLink}
      to={value?.link || ""}
      disablePadding
      sx={listItemStyle}
      
    >
      <ListItemButton
        className="list-item list_text  rounded-3 px-3 py-2 "
        sx={{ ...buttonStyle }}
      >
        <ListItemIcon className="myIconClass" sx={{ color: "#A7AEBF", marginRight: -3 }}> {value.icon}</ListItemIcon>
        <ListItemText className="" primary={<Typography variant="body1" style={{ fontSize: 16, color: "#fff", paddingLeft: 0 }} title={value.label}>{value.label}</Typography>} />
      </ListItemButton>
    </ListItem> :

      <ListItemButton className="list-item list_text no_link_list_item "
        sx={{ ...buttonStyle, "&:hover": { backgroundColor: "" } }}
      >
        <ListItemIcon className="myIconClass" sx={{ color: "#fff", }}>{value.icon}</ListItemIcon>
        <ListItemText className="" primary={<Typography variant="body2" style={{ fontSize: 16, color: "#A7AEBF", fontWeight: "bold" }} title={value.label}>{value.label}</Typography>} />
      </ListItemButton>
  );
};
